import * as React from "react"

const MOBILE_BREAKPOINT = 768

/**
 * useIsMobile hook optimized for SEO.
 * Defaults to false (Desktop) to ensure server-side rendering (SSR) 
 * always provides content to search engine crawlers.
 */
export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    
    const check = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
    }

    // Initial check
    check()

    mql.addEventListener("change", check)
    return () => mql.removeEventListener("change", check)
  }, [])

  return isMobile
}
